import { Injectable, EventEmitter } from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { ActivatedRoute } from '@angular/router';
import { PlatformCommand, ContentScope } from '@shared/commands/command-base';
import { DialogModel } from '@shared/models/dialog.model';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';
import { DialogService } from '@shared/services/dialog-service';
import {select, Store} from '@ngrx/store';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {skip, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {QueryProvider} from "@shared/queries/query-provider";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {DynamicFieldItem} from "@shared/components/dynamic-form/dynamic-form-item";
import {DynamicFormService} from "@shared/services/dynamic-form.service";
import {BasketId, SourceTypes} from "@features/dac6-reporter/Fields";
import {BasketProvider} from "@shared/models/basket-provider";
import {UpdatePreArrangementCommand} from "@features/dac6-reporter/commands/dac6-reporter.command";
import {Guid} from "guid-typescript";
import {CommandService} from "@core/services/command.service";
import {Configuration} from "@shared/models/configuration";

@Injectable({
  providedIn: 'root',
})

export class PlatformToolDac6PreArrangementDetailHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  activatedRoute?: ActivatedRoute;
  metaData?: any;

  item: any;
  id: string;
  ngUnsubscribe$ = new Subject<void>();
  isAutoTagRefresh: boolean;
  formField: DynamicFieldItem;
  fieldConfig: any;
  editedFields: string[] = [];
  endpointName: string;
  selectedSectionHearderKey: string;
  constructor(
    private dynamicFormService: DynamicFormService,
    private commandService: CommandService,
    private dialogService: DialogService,
    private collaborationStore: Store<CollaborationState>,
    private queryState: Store<IQueryState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private fileStoreCommonService: FileStoreCommonService) {
      this.invalidateSubject = new InvalidateSubject();
      this.endpointName = 'Dac6Api';
      this.selectedSectionHearderKey = '';
    }

  executeCommand(command: PlatformCommand) {
    this.item = this.magicLinkModel.fieldValues['item'];
    this.id = this.item.id;
    console.log(command);
    switch (command.name) {
      case 'SaveChanges':
        this.save(command);
        break;
      case 'PreArrangementDetailOpenConversationCommand':
        this.openConversation();
        break;
      case 'PreArrangementDetailViewDocumentsCommand':
        this.navigateToCaseFolder();
        break;
      case 'PreArrangementDetailHallmarkTaggingCommand':
        this.openHallmarkTagging();
        break;
    }
  }

  valueChanged($event: any) {
    if ($event && $event.action === 'ApplyTagsSuccess') {
      this.isAutoTagRefresh = true;
      QueryProvider.invokeQuery(this.queryState, 'PreArrangementRowById', {'[ID]': this.id});
      this.invalidateSubject.invalidate('ApplyTagsSuccess|' + Guid.create().toString());
      return;
    }
  }
  setSelectedTab(selectedTab: TabModel): void {
    console.log(this.magicLinkModel);
    this.ngUnsubscribe$ = new Subject<void>();
    this.dynamicFormService.initialize();
    this.id = this.magicLinkModel.fieldValues['Id']; // will be gotten from magic link
    this.endpointName = this.magicLinkModel.fieldValues['Api'];
    this.trackPreArrangementViewActivity(this.id);
    this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'PreArrangementRowById'))
      .pipe(skip(1), takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (this.isAutoTagRefresh) {
        this.isAutoTagRefresh = false;
        this.autoTagRefresh(state);
        return;
      }
      const item = state.item;
      if (item && item.cells) {
        if (!this.item) {
          this.item = item;
          this.magicLinkModel.fieldValues['item'] = this.item;
        }
        this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: this.item.cells['ReferenceCode'].value, title: this.item.cells['CaseId'].value, isDefault: false, isUserAction: false}));
        this.formField = state.formField;
        this.dynamicFormService.emitFormField(this.formField);
        this.fieldConfig = state.fieldConfig;
        this.dynamicFormService.emitFieldConfig(this.fieldConfig);
        Object.keys(item.cells).forEach(key => {
          if (!this.item.cells[key]) {
            this.item.cells[key] = {};
          }

          this.item.cells[key].isDirty = false;
          this.item.cells[key].actualValue = item.cells[key].value;
          this.item.cells[key].value = item.cells[key].value;
          this.item.cells[key].displayText = item.cells[key].displayText;
        });
        this.dynamicFormService.emitItems(this.item);
        this.isReadyToLoadContainer();
      }
      this.editedFields.splice(0, this.editedFields.length);
      this.dynamicFormService.emitEditedFields(this.editedFields);
      this.dynamicFormService.emitContainerClass("content  pos-relative");
    });
    QueryProvider.invokeQuery(this.queryState, 'PreArrangementRowById', {'[ID]': this.id});
  }

  selectionChanged?($event: any): void {

  }
  onFieldSectionChanged?($event: any): void {

  }
  onFieldSectionIndexChanged?($event: any): void {
    this.selectedSectionHearderKey = $event;
    if(this.hasHallmarkTagging()){
      this.magicLinkModel.breadcrumbBar.items[0].commands[0].isDisabled = false;
    } else {
      this.magicLinkModel.breadcrumbBar.items[0].commands[0].isDisabled = true;
    }
  }

  hasHallmarkTagging() {
    const currentBasket = Configuration.getCurrentBasket();
    if (currentBasket) {
      return currentBasket.basketKey === '' && this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
    }
    return this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
  }


  private isReadyToLoadContainer(){
    if(this.formField && this.item){
      this.dynamicFormService.emitIsReadyToLoadContainer(true);
    }
    else{
      this.dynamicFormService.emitIsReadyToLoadContainer(false);
    }
  }
  trackPreArrangementViewActivity(id: string){
    const command = new PlatformCommand('TrackPreArrangementViewCommand','DAC6Api');
    command.fieldValues['Id'] = id;
    command.fieldValues['SourceType'] = SourceTypes.PreArrangement;
    this.commandService.executePlatformCommand(command).subscribe((response: any)=>{
      console.log(response);
    })
  }
  openConversation() {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: this.item.cells['CaseGUID'].value,
        caseId: this.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${this.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      this.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  navigateToCaseFolder() {
    let relativePath = 'DAC6 Reporter/[CASE_ID]/Pre-Arrangements';
    const caseId = this.item.cells['CaseId'].value;
    relativePath = relativePath.replace('[CASE_ID]', caseId);
    this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
  }
  openHallmarkTagging() {
    const dialogueModel = DialogModel.create('Hallmark Tagging', 'HallmarkTagSuggestionDialogComponent', {});
    dialogueModel.maxWidth = '600px';
    dialogueModel.minWidth = '600px';
    this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
      if (res.action === 'OK') {
      }
    });
  }

  private autoTagRefresh(state: any) {
    if (!this.item.cells['Suggested_Hallmarks']) {
      this.item.cells['Suggested_Hallmarks'] = {};
    }
    if (!this.item.cells['ApplyTags']) {
      this.item.cells['ApplyTags'] = {};
    }

    if (state.item.cells['Suggested_Hallmarks'] && state.item.cells['Suggested_Hallmarks'].value) {
      this.item.cells['Suggested_Hallmarks'].isDirty = false;
      this.item.cells['Suggested_Hallmarks'].actualValue = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].value = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].displayText = state.item.cells['Suggested_Hallmarks'].displayText;
    }

    if (state.item.cells['ApplyTags'] && state.item.cells['ApplyTags'].value) {
      this.item.cells['ApplyTags'].isDirty = false;
      this.item.cells['ApplyTags'].actualValue = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].value = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].displayText = state.item.cells['ApplyTags'].displayText;
    }
  }

  save(command: PlatformCommand){
    this.editedFields = command.fieldValues['editedFields'];
    const item = command.fieldValues['item'];
    if (this.editedFields.length) {
      const command = new UpdatePreArrangementCommand(item);
      const currentBasket = BasketProvider.getCurrentBasket();
      switch (currentBasket.id){
        case BasketId.Mexico:
          command.IsHallmarkAutomatedCopy = true;
          break;
        default:
      }
      this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(commandState => {
        // this.snackBarService.showInformation('Pre Arrangement Data Saved');
        QueryProvider.invokeQuery(this.queryState, 'PreArrangementRowById', {'[ID]': this.id});
        this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
      });
    } else {
      this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
    }
  }

  destroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
